type Holiday = {
  uuid: string;
  name: string;
  day: string;
  holidayDate: string;
};

const holiday: Holiday = {
  uuid: "",
  name: "",
  day: "",
  holidayDate: "",
};
export type { Holiday };

export { holiday };
